var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",style:({
    border: _vm.Data.border,
    background: _vm.Data.background,
    color: _vm.Data.color,
  })},[(_vm.Data.iconfont)?_c('i',{class:_vm.Data.iconfont}):_vm._e(),_c('div',{staticClass:"name"},[_vm._v("\n    "+_vm._s(_vm.Data.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }